import React from "react";
import AmpButton from "../AmpButton/AmpButton";
import { useTranslation } from "react-i18next";
import styles from  "./AmpPagination.module.css";

export interface AmpPaginationProps {
    totalPages: number,
    totalRecords: number,
    setCurrentPage: (currentpage: number) => void,
    currentPage: number,
    recordsPerPage: number
}

export default function AmpPagination(props: AmpPaginationProps) {

    const { t } = useTranslation('propertySelectionList');

    const displayPageButtons = () => {
        const buttons: JSX.Element[] = [];
        if (props.totalPages === 0) {
            buttons.push(
                <AmpButton text={"1"} disabled onClick={() => {return}} type={"submit"}/>
            );
            return buttons;
        }

        if (props.currentPage > props.totalPages) {
            props.setCurrentPage(1);
        }
        for (let i = Math.max(0, Math.min(props.currentPage + 3, props.totalPages) - 7); i < Math.min(Math.max(0, props.currentPage - 4) + 7, props.totalPages); i++) {
            buttons.push(
                
                <AmpButton
                    atlStyle={props.currentPage === (i + 1)}
                    type={props.currentPage === (i + 1) ? "submit" : "cancel"}
                    key={`propertyListPageButton${i + 1}`}
                    onClick={(e) => changePage(i + 1)}
                    testId={`property-list-page-${i + 1}-test`}
                    text={`${i + 1}`}/>
            );
        }
        return buttons;
    }

    const changePage = (page: number) => {
        props.setCurrentPage(page);
    }

    const recordsPerPage = props.recordsPerPage;
    return (
        <div className={styles.PaginationParent}>
            <div className={styles.FooterDiv}>
                <AmpButton atlStyle onClick={() => { changePage(1); } } disabled={(props.totalPages === 0)} testId="property-list-first-page-test" key="property-list-first-page" text="«" type={"cancel"}/>
                <AmpButton atlStyle onClick={() => { changePage(Math.max(props.currentPage - 1, 1)); } } disabled={(props.totalPages === 0)} testId="property-list-prev-page-test" key="property-list-prev-page" text="<" type={"cancel"}/>
                {displayPageButtons()}
                <AmpButton atlStyle onClick={() => { changePage(Math.min(props.currentPage + 1, props.totalPages)); } } disabled={(props.totalPages === 0)} testId="property-list-next-page-test" key="property-list-next-page" text=">" type={"cancel"}/>
                <AmpButton atlStyle onClick={() => { changePage(props.totalPages); } } disabled={(props.totalPages === 0)} testId="property-list-last-page-test" key="property-list-last-page" text="»" type={"cancel"}/>
            </div>
            <div className={styles.FooterDiv}>{t("property-list-table.pagination-description-1") as string} {Math.min(props.totalRecords, (props.currentPage - 1) * recordsPerPage + 1)} - {Math.min(props.currentPage * recordsPerPage, props.totalRecords)} {t("property-list-table.pagination-description-2") as string} {props.totalRecords}</div>
        </div>
    );
}